import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getIncidents(options = {}) {

	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENTS,
		options
	)
}
function _getIncidentPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_PREVIEW,
		options
	)
}
function _getIncidentPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_POPUP,
		options
	)
}

function _createIncident(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].CREATE_INCIDENT,
		options
	)
}

function _getIncident(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT,
		options
	)
}

function _patchIncident(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT,
		options
	)
}

function _patchIncidentClose(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT_CLOSE,
		options
	)
}

function _putIncident(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].PUT_INCIDENT,
		options
	)
}

function _deleteIncident(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS].DELETE_INCIDENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENTS]: _getIncidents,
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_PREVIEW]: _getIncidentPreview,
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_POPUP]: _getIncidentPopup,
	[ModulesConfigMap[ModulesMap.INCIDENTS].CREATE_INCIDENT]: _createIncident,
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT]: _getIncident,
	[ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT]: _patchIncident,
	[ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT_CLOSE]: _patchIncidentClose,
	[ModulesConfigMap[ModulesMap.INCIDENTS].PUT_INCIDENT]: _putIncident,
	[ModulesConfigMap[ModulesMap.INCIDENTS].DELETE_INCIDENT]: _deleteIncident,
}
